// extracted by mini-css-extract-plugin
export default {"socketDisconnectionMessage":"socketContext_socketDisconnectionMessage__g-K78","refreshLink":"socketContext_refreshLink__LtMNf"};